import React from 'react';
export function StickyBuyBox({
  config,
  selectedPack,
  onPackSelect
}) {
  // Function to scroll to the BUY NOW button
  const scrollToBuySection = () => {
    const buyButton = document.getElementById('hero-buy-button');
    if (buyButton) {
      // Scroll the button into view with some padding
      buyButton.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } else {
      // Fallback to hero section if button not found
      const heroSection = document.getElementById('hero-section');
      if (heroSection) {
        heroSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 z-50 py-3 px-4" data-id="element-372">
      <div className="container mx-auto" data-id="element-373">
        <div className="flex items-center justify-between" data-id="element-374">
          <div className="flex items-center" data-id="element-375">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/52g4MoAq1cHo7CL6EJvFQs/Untitled_design_%284%29.png" alt="MyoQuell patch" className="w-12 h-12 rounded object-cover mr-4 hidden sm:block" data-id="element-376" />
            <div data-id="element-377">
              <h3 className="font-bold text-sm sm:text-base" data-id="element-378">
                MyoQuell™ Herbal Knee Patches
              </h3>
            </div>
          </div>
          <div data-id="element-379">
            <button onClick={scrollToBuySection} className="py-2 px-4 sm:px-6 bg-[#1A3C2A] text-white font-medium rounded-full hover:bg-[#142E20] focus:outline-none focus:ring-2 focus:ring-[#6B9C37] focus:ring-offset-2 transition-colors text-sm sm:text-base whitespace-nowrap" data-id="element-380">
              GET YOURS
            </button>
          </div>
        </div>
      </div>
    </div>;
}